import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getCalendar() {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_URL}Calendario_Curso_20262027.pdf`, {
      responseType: 'arraybuffer',
    });
    return response;

  } catch (error) {
    console.error('Error al obtener el Calendario del curso', error);
  }
}
